import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import NotFound from '@/components/pages/errors/NotFound'

Vue.use(Router)

// Add a catch all for 404
routes.push({
  path: '*',
  component: NotFound
})

const router = new Router({
  routes,
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})
router.afterEach((to) => {
  gtag('config', window.GA_TRACKING_ID, {
    page_path: to.fullPath,
    app_name: 'Harling Taxis',
    send_page_view: true
  })
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js